import { createStyles, makeStyles } from '@mui/styles'
import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import MuiAccordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      marginTop: '0px',
      marginBottom: '30px',
    },
    sectionRoot: {
      '--widgets-spacing': '20px',
    },
    sectionChild: {
      '&:not(:first-child)': {
        marginTop: '10px',
        marginBottom: '0px',
      },
    },
    sectionContainer: {
      maxWidth: '881px',
      display: 'flex',
      marginRight: 'auto',
      marginLeft: 'auto',
      position: 'relative',
    },
    sectionColumn: {
      position: 'relative',
      minHeight: '1px',
      display: 'flex',
      width: '100%',
    },
    sectionWidgetRibbon: {
      position: 'absolute',
      zIndex: 1,
      maxWidth: '100%',
      marginBottom: 0,
      color: '#ffffff',
      fontWeight: 500,
      width: 'auto',
      // maxWidth: 'auto',
      top: '0px',
      left: '52px',
      '& $sectionWidgetContainer': {
        margin: '0px 0px 0px 0px',
        padding: '10px 20px 10px 20px',
        backgroundColor: '#3bbbe6',
      },
    },
    sectionWidgetContainer: {
      transition:
        'background .3s,border .3s,border-radius .3s,box-shadow .3s,transform var(--e-transform-transition-duration,.4s)',
      [theme.breakpoints.down('sm')]: {
        '& img': {
          width: '150px!important',
        },
      },
    },
    sectionWidgetElement: {
      width: '100%',
      '&:not(:last-child)': {
        marginBottom: '20px',
      },
    },
    title: {
      fontSize: '25px',
      fontWeight: '700',
      lineHeight: '34px',
      '& $sectionWidgetContainer': {
        margin: '5px 0px 0px 0px',
      },
    },
    detailText: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
      '& $sectionWidgetContainer': {
        margin: '0px 0px 0px 0px',
      },
    },
    widgetInner: {
      display: 'flex',
      position: 'relative',
      width: '100%',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
      padding: '10px',
    },
    titleInner: {
      fontSize: '22px',
      fontWeight: '600',
      lineHeight: '20px',
      '& $sectionWidgetContainer': {
        margin: '25px 0px 0px 0px',
      },
    },
    subTitleInner: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
      '& $sectionWidgetContainer': {
        margin: '-15px 0px 0px 0px',
      },
    },
  }),
)

export const SectionWidget = styled('div')(({ widgetColor, theme }) => {
  return {
    backgroundColor: widgetColor,
    display: 'flex',
    position: 'relative',
    width: '100%',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    borderStyle: widgetColor === '#ffffff' ? 'solid' : 'none',
    borderWidth: widgetColor === '#ffffff' ? '1px 1px 1px 1px' : 'none',
    borderColor: widgetColor === '#ffffff' ? '#454545' : widgetColor,
    transition: 'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
    margin: '0px 0px 0px 0px',
    '--e-column-margin-right': '0px',
    '--e-column-margin-left': '0px',
    padding: '30px 50px 30px 50px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 10px 0px 10px',
    },
  }
})

export const Title = styled('div')(({ textColor, theme }) => {
  return {
    color: textColor ? textColor : '#15261e',
  }
})

export const SubAccordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ bgcolor, theme }) => ({
  // border: `1px solid ${bgcolor ? bgcolor : theme.palette.divider}`,
  borderRadius: '5px',
  '&:not(:last-child)': {
    borderBottom: 0,
    marginBottom: '10px',
  },
  '&:before': {
    display: 'none',
  },
}))

export const SubAccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ bgcolor, textcolor, theme }) => ({
  color: textcolor,
  backgroundColor: bgcolor ? bgcolor : '#ffffff',
  flexDirection: 'row',
  borderRadius: '5px',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: textcolor,
  },
  '& .MuiAccordionSummary-content': {
    marginRight: theme.spacing(1),
  },
  '&.Mui-disabled': {
    opacity: 1,
  },
  '&.Mui-expanded': {
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '0px',
    borderBottomLeftRadius: '0px',
  },
}))

export const SubAccordionDetails = styled(MuiAccordionDetails)(({ bgcolor, theme }) => ({
  backgroundColor: bgcolor ? bgcolor : '#ffffff',
  // paddingTop: '0px',
  padding: `0px ${theme.spacing(2)}`,
  borderTop: '1px solid rgba(0, 0, 0, .125)',
  borderBottomRightRadius: '5px',
  borderBottomLeftRadius: '5px',
}))
